var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"appsectioncategories container",attrs:{"aria-labelledby":_vm.id}},[_c('h2',{staticClass:"h1 tea-center",attrs:{"id":_vm.id}},[_vm._v(_vm._s(_vm.$t('appsectioncategories.title')))]),_c('app-category-card-list')],1)}
var staticRenderFns = []

export { render, staticRenderFns }